export const environment = {
  production: false,
  apiServer: 'https://feez-backend-dev-5832476b7ad2.herokuapp.com',
  appName: 'Feez dev',
  auth0: {
    domain: 'compleo-dev.eu.auth0.com',
    clientId: 'T6vmYJQasAGPazUGwiyljWvnoyPQB2ht', //public - ok
    audience: 'https://api.compleo.dev',
    redirectUri: 'https://dev.compleo.accountant'
  }
};
